import { Document } from "../../../entities/Document";

export class DocumentMapper {
    static map(document: Document): Document {
        delete document.__typename;
        return document;
    }
}
